var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FF007F;}\n"),React.createElement("path",{"className":"st0","d":"M9,0C4,0,0,4,0,9s4,9,9,9s9-4,9-9S14,0,9,0z M13.8,11.1c-0.4,0.4-0.9,0.3-1.3,0L9,7.6l-3.6,3.6\n\tc-0.4,0.4-0.9,0.3-1.3,0c-0.4-0.4-0.3-0.9,0-1.3l4.2-4.2C8.6,5.5,8.8,5.4,9,5.4c0.2,0,0.5,0.1,0.6,0.3l4.2,4.2\n\tC14.2,10.2,14.2,10.8,13.8,11.1z","key":1})]);
}

ChevronUp.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 18 18","style":{"enableBackground":"new 0 0 18 18"},"xmlSpace":"preserve"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
